import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCartData } from 'store/cartSlice/selectors';

export interface PaymentMethod {
  name: string;
  type: string;
}

const usePaymentMethods = (cartIsFree: boolean) => {
  const {
    selectedEvent: { id },
    uuid: cartUUID,
  } = useSelector(selectCartData);
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const requestPaymentMethods = async () => {
    setIsLoading(true);
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/events/${id}/tickets/payment`,
      {
        order_id: cartUUID,
      },
    );

    setPaymentMethods(response.data.data);
    setIsLoading(false);
  };

  useEffect(() => {
    if (!cartIsFree) {
      requestPaymentMethods();
    }
  }, []);

  return { paymentMethods, isLoading };
};

export default usePaymentMethods;
